<template>
    <div>
        <div class="detail-tabs__timetable chapter-title ellipsis" @click="onSpreadChapter">
            <div class="chapter-order">{{sectionList.idx_name}}</div>
            <div class="chapter-name">{{sectionList.chapter_name}}</div>
            <img src="https://hks.gsxcdn.com/1534447862_wzkykuhh.jpg" alt="" :class="spread ? 'icon-openup' : 'icon-opendown'">
        </div>
        <div v-show="spread">
            <div
                v-for="(item,index) in sectionList.lecture_list"
                :key="index"
                class="detail-tabs__timetable chapter-item ellipsis">
                <span class="detail-order">第{{item.idx}}讲</span>
                <div class="detail-title">{{item.lecture_title}}</div>
                <span v-if="item.introduction || item.clazz_hours_desc" class="detail-seprator">|</span>
                <div class="detail-time">{{item.introduction}}
                    <span v-if="item.clazz_hours_desc">{{item.clazz_hours_desc}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        sectionList: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            spread: false
        };
    },
    methods: {
        onSpreadChapter() {
            this.spread = !this.spread
        }
    }

}
</script>

<style lang="less" scoped>
    .detail-tabs__timetable {
        position: relative;
        margin: 0 30px;
        font-size: 16px;
        line-height: 18px;
        padding: 28px 0;
        color: #000000;
        border-bottom: 1px solid #f5f5f5;
    }

    .chapter-title {
        font-weight: 600;
        display: flex;

        .chapter-order {
            margin-right: 20px;
            width: 60px;
            text-align: right;
        }
    }


    .icon-openup {
        position: absolute;
        top: 50%;
        right: 0;
        width: 25px;
        transform: translate(0, -50%);
    }

    .icon-opendown {
        position: absolute;
        top: 50%;
        right: 0;
        width: 25px;
        transform: translate(0, -50%) rotate(180deg);
    }

    .chapter-item {
        display: flex;
        padding-left: 80px;

        .detail-order {
            margin-right: 21px;
        }

        .detail-title {
            max-width: 280px;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .detail-seprator {
           margin: 0 20px;
           color: #818597;
        }

        .detail-time {
            color: #818597;
            span::before {
                content: "·";
                margin: 0 6px;
            }
        }
    }


</style>